const tableColumns = [
  {
    title: 'Machine ID',
    dataIndex: 'machineid',
    key: 'machineid',
  },
  {
    title: 'Start Time',
    dataIndex: 'starttime',
    key: 'starttime',
  },
  {
    title: 'End Time',
    dataIndex: 'endtime',
    key: 'endtime',
  },
  {
    title: 'Duration (seconds)',
    dataIndex: 'duration',
    key: 'duration',
  },
  {
    title: 'Prev End Time',
    dataIndex: 'prevendtime',
    key: 'prevendtime',
    align: 'left',
  },
  {
    title: 'Idle Time',
    dataIndex: 'idletime',
    key: 'idletime',
    align: 'left',
  },
  {
    title: 'Run Time',
    dataIndex: 'runtime',
    key: 'runtime',
    align: 'left',
  },
  // {
  //   title: 'Actions',
  //   dataIndex: 'action',
  //   key: 'action',
  //   width: '90px',
  // },
];

export { tableColumns };
